import { Breadcrumb, Tag, Typography } from 'antd'
import { Icon } from '@iconify/react';
import { useQuery } from '@apollo/client';
import { GET_STATUS_FLOW } from '../../Graphql/queries/getQueries';
import Spiner from '../Spiner/Spiner';

function LeadStatusFlow({ leadId }) {
    const { error, loading, data } = useQuery(GET_STATUS_FLOW, {
        variables: {
            lead_id: leadId
        },
    })
    const leadStatusFlow = data?.StatusFlow?.nodes.map(({ status }) => {
        return status
    })
    const statusTags = (status) => {
        return (
            <Breadcrumb.Item key={status.key}>
                <Tag color={status.color} >
                    {status.text}
                </Tag>
            </Breadcrumb.Item>
        );
    }
    if (loading) return <Spiner />
    return (
        <div className='lead_comp_container flex_ver' style={{ width: '100%', height: 'fit-content', gap: 10 }}>
            <Typography.Title level={5}>Lead Status Flow</Typography.Title>
            <div className='flex_center_ver ' style={{ gap: 5 }}>
                <Tag color={leadStatusFlow[leadStatusFlow?.length - 1]?.color} style={{ borderRadius: 8 }} >{leadStatusFlow[leadStatusFlow?.length - 1]?.text} </Tag>
                <Icon icon="material-symbols:arrow-right-alt-rounded" color="#b2b2b2" fontSize={40} />
                <Breadcrumb separator={<span style={{ color: 'gray', margin: '0 2px' }}>/</span>}>
                    {leadStatusFlow?.map(statusTags)}
                </Breadcrumb>
            </div>

        </div>
    )
}

export default LeadStatusFlow